import {useQuery} from 'react-query';

import {queryClient} from 'client/common/utils/react-query';
import {
    getOrgs,
    getOrgSurveys,
    OrgsResponse,
    OrgSurveyResponse
} from 'client/common/utils/api-client';

const ORGS_KEY = 'ORGS';
const ORGS_CURRENT_KEY = [ORGS_KEY, 'current'] as const;

export const getOrgSurveysKey = () => {
    return [ORGS_KEY, 'surveys'] as const;
};

export function useOrgsList() {
    return useQuery([ORGS_KEY], async (): Promise<OrgsResponse> => {
        const {data} = await getOrgs();

        return data ?? [];
    });
}

export function useOrgSurveys(orgId: number) {
    return useQuery(getOrgSurveysKey(), async (): Promise<OrgSurveyResponse> => {
        const {data} = await getOrgSurveys(orgId);

        return data ?? [];
    });
}

const noop = async () => Promise.resolve(undefined);

function getOrgIdFromUrl() {
    const orgParam = new URLSearchParams(location.search).get('org') ?? undefined;

    return orgParam ? parseInt(orgParam, 10) : undefined;
}

export function useCurrentOrg() {
    const orgId = getOrgIdFromUrl();
    const {data} = useQuery(ORGS_CURRENT_KEY, noop, {enabled: false, initialData: orgId});

    return data;
}

export function getCurrentOrg(): number | undefined {
    return queryClient.getQueryData(ORGS_CURRENT_KEY);
}

export function setCurrentOrg(id: number) {
    queryClient.setQueryData(ORGS_CURRENT_KEY, () => id);
}
